import * as React from "react";
import { GrnAttachmentsProps } from "../../features/grn/types";
import GrnAttachments from "./GrnAttachments";

/**
 * Thin wrapper around GrnAttachments that wires the return/resolution
 * specific configuration. This removes the duplicated attachment logic
 * while preserving the existing API surface.
 */
const Grnresattachments: React.FC<GrnAttachmentsProps> = (props) => {
  return (
    <GrnAttachments
      {...props}
      variant="response"
      docCategoryName="GRN"
      allowMissingDocumentType
    />
  );
};

export default Grnresattachments;
